import { useState, useEffect } from 'react';
import { storage } from '../services/storage.service';

/**
 * useState with localStorage persistence via shared storage service.
 */
export function usePersistedState<T>(
  key: string,
  initialValue: T,
): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [state, setState] = useState<T>(() => {
    const stored = storage.get<T>(key);
    return stored !== null ? stored : initialValue;
  });

  useEffect(() => {
    storage.set(key, state);
  }, [key, state]);

  return [state, setState];
}

export default usePersistedState;
